import {
  archiveChat,
  attachTagToChat,
  detachTagFromChat,
  pinChat,
  unarchiveChat,
  unpinChat,
} from "../../api/whatsapp.js";
import type { ChatTag, WhatsappChat } from "../../types.ts";

export type ContextMenuState = {
  chat: WhatsappChat;
  x: number;
  y: number;
};

export function ChatContextMenu({
  menu,
  tags,
  onClose,
  onError,
}: {
  menu: ContextMenuState;
  tags: ChatTag[];
  onClose: () => void;
  onError: (message: string) => void;
}) {
  const attached = new Set(menu.chat.tagIds || []);
  const isPinned = !!menu.chat.pinnedAt;

  async function run(action: () => Promise<unknown>) {
    onClose();
    try {
      await action();
    } catch (err) {
      onError(err instanceof Error ? err.message : "Falha");
    }
  }

  return (
    <div
      className="wa-context-menu"
      style={{
        left: Math.min(menu.x, window.innerWidth - 240),
        top: Math.min(menu.y, window.innerHeight - 280),
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <button
        className="wa-context-item"
        type="button"
        onClick={() => void run(() => (isPinned ? unpinChat(menu.chat.chatJid) : pinChat(menu.chat.chatJid)))}
      >
        {isPinned ? "Desfixar" : "Fixar conversa"}
      </button>
      <button
        className="wa-context-item"
        type="button"
        onClick={() => void run(() => (
          menu.chat.archived
            ? unarchiveChat(menu.chat.chatJid)
            : archiveChat(menu.chat.chatJid)
        ))}
      >
        {menu.chat.archived ? "Desarquivar" : "Arquivar conversa"}
      </button>
      <div className="wa-context-sep">Tags</div>
      {tags.length ? tags.map((tag) => {
        const isOn = attached.has(tag.id);
        return (
          <button
            key={tag.id}
            className="wa-context-item wa-context-tag"
            type="button"
            onClick={() => void run(() => (
              isOn ? detachTagFromChat(menu.chat.chatJid, tag.id) : attachTagToChat(menu.chat.chatJid, tag.id)
            ))}
          >
            <span className="wa-context-tag-dot" style={{ background: tag.color }} />
            <span className="wa-context-tag-name">{tag.name}</span>
            {isOn ? <span className="wa-context-tag-check">OK</span> : null}
          </button>
        );
      }) : <div className="wa-context-empty">Nenhuma tag - crie em + Tag</div>}
    </div>
  );
}
